/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id   : 'home',
        title: 'Inicio',
        type : 'basic',
        icon : 'heroicons_outline:home',
        link : '/landing-home',
        allowedRoles: ['admin', 'user', 'operator']
    },
    {
        id  : 'divider-1',
        type: 'divider'
    },   
    {
        id      : 'system-cofig',
        title   : 'Viajes y pedidos',
        subtitle: 'Hotel',
        type    : 'group',
        icon    : 'heroicons_outline:menu', 
        allowedRoles: ['user'],    
        children: [
                {
                    id   : 'viajes',
                    title: 'Viajes',
                    type : 'basic',
                    icon : 'mat_outline:person',
                    link : '/hotel-sales',
                    allowedRoles: ['user']
                }]
    },
    {
        id      : 'system-cofig',
        title   : 'Gestión de Sistema',
        subtitle: 'Usuarios y Configuraciones',
        type    : 'group',
        icon    : 'heroicons_outline:menu', 
        allowedRoles: ['admin'],    
        children: [
                {
                    id   : 'persons',
                    title: 'Clientes',
                    type : 'basic',
                    icon : 'mat_outline:person',
                    link : '/persons',
                    allowedRoles: ['admin']
                },
                {
                    id   : 'person-groups',
                    title: 'Grupos de Personas',
                    type : 'basic',
                    icon : 'heroicons_outline:user-group',
                    link : '/person-groups',
                    allowedRoles: ['admin']
                },
                {
                    id   : 'products',
                    title: 'Productos',
                    type : 'basic',
                    icon : 'heroicons_outline:cube',
                    link : '/products',
                    allowedRoles: ['admin']
                },
                {
                    id   : 'users',
                    title: 'Usuarios',
                    type : 'basic',
                    icon : 'heroicons_outline:users',
                    link : '/users',
                    allowedRoles: ['admin']
                },
                {
                    id   : 'users',
                    title: 'Flota',
                    type : 'basic',
                    icon : 'mat_outline:directions_car',
                    link : '/vehicles',
                    allowedRoles: ['admin']
                },]
    },
    {
        id      : 'system-cofig',
        title   : 'Ventas y Cajas',
        subtitle: 'Ventas reportes y cajas',
        type    : 'group',
        icon    : 'heroicons_outline:menu', 
        allowedRoles: ['admin'],
        children: [
            {
                id   : 'pointOfSaleMovements',
                title: 'Cajas',
                type : 'basic',
                icon : 'mat_outline:point_of_sale',
                link : '/pointOfSaleMovements',
                allowedRoles: ['admin']
            },
            {
                id   : 'sales',
                title: 'Listado de Ventas',
                type : 'basic',
                icon : 'mat_outline:attach_money',
                link : '/sales',
                allowedRoles: ['admin']
            },
            {
                id   : 'dailyTravelReport',
                title: 'Viajes x Día',
                type : 'basic',
                icon : 'heroicons_outline:calendar',
                link : '/sales/daily-travel-report',
                allowedRoles: ['admin']
            },
            {
                id   : 'salePos',
                title: 'Ventas POS',
                type : 'basic',
                icon : 'mat_outline:point_of_sale',
                link : '/sales/sale-pos',
                allowedRoles: ['admin']
            }]
    },    
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
